const _excluded = ["moduleName", "scope", "renderLoader", "version"],
  _excluded2 = ["children"];
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React, { Suspense, useMemo } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { REPORT_TYPES, getRemoteRuntime, report } from '@adsk/exo-skeleton-api';
import { RemoteLoaderWrapper } from './RemoteLoaderWrapper';
import { EXO_SKELETON_SCOPE_NAME, REMOTE_MODULE_ERROR } from '../helpers/consts';
import { useCreateLazyRemoteComponent } from '../hooks/useCreateLazyRemoteComponent';
import { useRemoteTrackingHandler } from '../hooks/useRemoteTrackingHandler';
import { RemoteProvider, useRemote } from '../providers/RemoteProvider';

// eslint-disable-next-line @typescript-eslint/no-empty-object-type

// eslint-disable-next-line @typescript-eslint/no-empty-object-type
function LazyRemoteComponent(_ref) {
  let {
      moduleName,
      scope,
      renderLoader = () => null,
      version
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  const {
    moniker
  } = getRemoteRuntime(scope) || {};
  useRemoteTrackingHandler({
    scope,
    moduleName
  });
  const Component = useCreateLazyRemoteComponent({
    scope,
    moduleName,
    version
  });
  const componentContent = /*#__PURE__*/React.createElement(Component, props);
  return renderLoader ? /*#__PURE__*/React.createElement(Suspense, {
    fallback: /*#__PURE__*/React.createElement(RemoteLoaderWrapper, {
      scope: scope,
      moduleName: moduleName
    }, renderLoader({
      scope,
      moduleName,
      moniker
    }))
  }, componentContent) : componentContent;
}

// eslint-disable-next-line @typescript-eslint/no-empty-object-type
export const RemoteComponent = _ref2 => {
  let {
      children
    } = _ref2,
    props = _objectWithoutProperties(_ref2, _excluded2);
  const {
    moduleName,
    scope,
    renderError,
    version
  } = props;
  const {
    moniker,
    override
  } = getRemoteRuntime(scope) || {};
  const parentRemoteValue = useRemote();
  const childrenToRender = useMemo(() => {
    if (!children) return null;
    return parentRemoteValue ? /*#__PURE__*/React.createElement(RemoteProvider, parentRemoteValue, children) : children;
  }, [children, parentRemoteValue]);
  return /*#__PURE__*/React.createElement(ErrorBoundary, {
    fallbackRender: function () {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      return renderError === null || renderError === void 0 ? void 0 : renderError(...args);
    },
    resetKeys: [moniker, override, ...Object.values(props)],
    onError: error => {
      return report({
        scope: EXO_SKELETON_SCOPE_NAME,
        type: REPORT_TYPES.error,
        value: error,
        context: {},
        UNSAFE__globalContext: {
          type: REMOTE_MODULE_ERROR,
          moniker,
          override,
          scope,
          moduleName,
          module: moduleName,
          version
        }
      });
    }
  }, /*#__PURE__*/React.createElement(RemoteProvider, {
    scope: scope,
    moduleName: moduleName
  }, /*#__PURE__*/React.createElement(LazyRemoteComponent, props, childrenToRender)));
};
//# sourceMappingURL=RemoteComponent.js.map